import axios from 'axios';
import normalAxios from '../baseConfig';

const tokenAxios = axios.create({
    timeout: normalAxios.timeout, // 请求超时设置
    withCredentials: normalAxios.withCredentials // 跨域请求是否需要携带 cookie
});

tokenAxios.interceptors.request.use(
    (config) => {
        config = normalAxios.request(config);
        return config;
    },
    (error) => {
        return normalAxios.requestError(error);
    }
);

tokenAxios.interceptors.response.use(
    (response) => {
        return normalAxios.response(response);
    },
    (error) => {
        return normalAxios.responseError(error);
    }
);

export default tokenAxios;
